const testimonials = [
  {
    name: "Tech. Sgt. Michael D.",
    location: "McConnell AFB, KS",
    rating: 5,
    text: "Received PCS orders to Ramstein with 21 days to report. My wife's passport had expired while we were stationed stateside. Fast Passport Center walked us through the renewal, reviewed every document, and got her passport back in five business days. Made our report date without a single issue. Cannot recommend them enough to any AF family.",
    service: "Family Expedited Passports",
  },
  {
    name: "Lauren H.",
    location: "College Hill, Wichita",
    rating: 5,
    text: "I'm a project engineer at Spirit AeroSystems and had a supplier visit to Toulouse, France, booked with two weeks notice. My passport expired during COVID when I wasn't traveling. Fast Passport Center had my renewal processed and back in four business days. Professional, fast, and worth every penny for the peace of mind.",
    service: "Passport Renewal",
  },
  {
    name: "David & Maria G.",
    location: "Andover, KS",
    rating: 5,
    text: "We booked a family reunion in Mexico and realized three weeks out our youngest daughter never had a passport. Fast Passport Center guided us through the new child passport process, and we had it in seven business days. The checklist and document review made all the difference for first-time applicants.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function WichitaTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What South Central Kansas Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Wichita, McConnell AFB, and Andover travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}